import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/pages/Login/Login'
import RememberPassword from '@/pages/Login/RememberPassword'
import Layout from '@/components/Layout/Layout'
import ThemeButton from '@/components/ThemeButton/SunMoon'
import MiddPage from '@/components/Header/MiddPage'
// Main
import Dashboard from '@/pages/Dashboard/Dashboard'
import DashboardSales from '@/pages/Dashboard/DashboardSales'
import DefineDastresi from '@/pages/BnpSys/DefineDastresi'
import ViewHistory from '@/pages/Public/ViewHistory'
import TarifKarbaran from '@/pages/BnpSys/TarifKarbaran'
import DetailTarifKarbaran from '@/pages/BnpSys/DetailTarifKarbaran'
import TanzimatUser from '@/pages/BnpSys/TanzimatUser'
import UserLogInformation from '@/pages/BnpSys/UserLogInformation'
import CustomerManager from '@/pages/BnpCrm/UserMenu/CustomerManager'
import MargeCustomer from '@/pages/BnpCrm/UserMenu/MargeCustomer.vue'
import MyProfile from '@/pages/BnpCrm/UserMenu/MyProfile'
import Survey from '@/pages/BnpCrm/BaseMenu/Survey'
import DetailSurvey from '@/pages/BnpCrm/BaseMenu/DetailSurvey'
import Grouping from '@/pages/BnpCrm/BaseMenu/Grouping'
import Cataloge from '@/pages/BnpCrm/BaseMenu/Cataloge'
import NoticeBoard from '@/pages/BnpCrm/BaseMenu/NoticeBoard'
import DetailCustomer from '@/pages/BnpCrm/UserMenu/DetailCustomer'
import AddCustomer from '@/pages/BnpCrm/UserMenu/AddCustomer'
import DefineShobe from '@/pages/BnpSys/DefineShobe'
import DetailDefineShobe from '@/pages/BnpSys/DetailDefineShobe'
import SmsTemplate from '@/pages/BnpSys/SmsTemplate'
import DefineInfoSystem from '@/pages/BnpSys/DefineInfoSystem'
import DetailDefineInfoSystem from '@/pages/BnpSys/DetailDefineInfoSystem'
import TarifSematha from '@/pages/BnpSys/TarifSematha'
import DetailTarifSematha from '@/pages/BnpSys/DetailTarifSematha'
import Task from '@/pages/BnpCrm/Tasks/Task'
import DetailTask from '@/pages/BnpCrm/Tasks/DetailTask'
import TaskManager from '@/pages/BnpCrm/Tasks/TaskManager'
import Contract from '@/pages/BnpCrm/Contracts/Contract'
import Factor from '@/pages/BnpCrm/Contracts/Factor'
import TempFactor from '@/pages/BnpCrm/Contracts/TempFactor'
import FactorManager from '@/pages/BnpCrm/Contracts/FactorManager'
import CartableContract from '@/pages/BnpCrm/Contracts/CartableContract'
import DetailContract from '@/pages/BnpCrm/Contracts/DetailContract'
import Department from '@/pages/BnpCrm/Department/Department'
import CustomerSms from '@/pages/BnpCrm/SmsPanel/CustomerSms'
import DetailCustomerProduct from '@/pages/BnpCrm/Contracts/DetailCustomerProduct'
import Products from '@/pages/BnpCrm/Products/Products'
import MenuManager from '@/pages/BnpSys/MenuManager'
import Tickets from '@/pages/BnpCrm/Support/Tickets'
import CreateTicket from '@/pages/BnpCrm/Support/CreateTicket'
import PersonelTicket from '@/pages/BnpCrm/PersonelTicket/PersonelTicket'
import Deposit from '@/pages/BnpCrm/Contracts/Deposit'
import EducationManage from '@/pages/BnpCrm/FileCenter/EducationManage'
import FileManage from '@/pages/BnpCrm/FileCenter/FileManage'
import EducationCenter from '@/pages/BnpCrm/FileCenter/EducationCenter'
import FileCenter from '@/pages/BnpCrm/FileCenter/FileCenter'
import Myfiles from '@/pages/BnpCrm/FileCenter/Myfiles'
import Modules from '@/pages/BnpCrm/Modules/Modules'
import DetailModules from '@/pages/BnpCrm/Modules/DetailModules'
import ServiceBuy from '@/pages/BnpCrm/CustomerPage/ServiceBuy'
import MyProducts from '@/pages/BnpCrm/CustomerPage/MyProducts'
import MyTempFactors from '@/pages/BnpCrm/CustomerPage/MyFactors/MyTempFactors'
import MyFactors from '@/pages/BnpCrm/CustomerPage/MyFactors/MyFactors'
import ChatRoom from '@/pages/BnpCrm/Support/ChatRoom'
import SimilarCustomers from '@/pages/BnpCrm/Reports/SimilarCustomers'
import DemoRequest from '@/pages/BnpCrm/Reports/DemoRequest'
import ContractReminderReport from '@/pages/BnpCrm/Reports/ContractReminderReport'
import NoFactor from '@/pages/BnpCrm/Reports/NoFactor'
import TicketReport from '@/pages/BnpCrm/Reports/TicketReport'
import SaleReport from '@/pages/BnpCrm/Reports/SaleReport'
import DemoReport from '@/pages/BnpCrm/Reports/DemoReport'
import GardeshHesab from '@/pages/BnpCrm/Reports/GardeshHesab'
import marketerCalls from '@/pages/BnpCrm/Reports/marketerCalls'
import DebtorList from '@/pages/BnpCrm/Reports/DebtorList'
import developRport from '@/pages/BnpCrm/Reports/developRport'
import SmsReport from '@/pages/BnpCrm/Reports/SmsReport'
import markentingReport from '@/pages/BnpCrm/Reports/markentingReport'
import ActiveNoSupport from '@/pages/BnpCrm/Reports/ActiveNoSupport'
import CustomerScore from '@/pages/BnpCrm/Reports/CustomerScore'
import CustomerTicket from '@/pages/BnpCrm/Support/CustomerTicket'
import UserIdTask from '@/pages/BnpCrm/Tasks/UserIdTask'
import ReplyTask from '@/pages/BnpCrm/Tasks/ReplyTask'
import Verify from '@/pages/Login/Verify'
import PrintFactor from '@/pages/print/PrintFactor'
import Print from '@/pages/print/Print'
import PrintTempFactor from '@/pages/print/PrintTempFactor'
import OnlinePayment from '@/pages/BnpCrm/CustomerPage/OnlinePayment'
import TicketAnswer from '@/pages/BnpCrm/Support/TicketAnswer'
import Alarm from '@/pages/BnpCrm/UserMenu/Components/Alarm'
import CustomerFinancialInvoice from '@/pages/BnpCrm/UserMenu/Components/CustomerFinancialInvoice'
import DetailAlarm from '@/pages/BnpCrm/UserMenu/Components/DetailAlarm'
import EmailSetting from '@/pages/BnpCrm/Email/EmailSetting'
import DetailEmailSetting from '@/pages/BnpCrm/Email/DetailEmailSetting'
import Phonebook from '@/pages/BnpCrm/Phonebook/Phonebook'
import SendEmail from '@/pages/BnpCrm/Email/SendEmail'
import Inbox from '@/pages/BnpCrm/Email/Inbox'
import WorkTips from '@/pages/BnpCrm/WorkTips/WorkTips'
import license from '@/pages/BnpSys/license'
import Detaillicense from '@/pages/BnpSys/Detaillicense'
import ChekLicense from '@/pages/License/ChekLicense'
import PriceList from '@/pages/BnpCrm/Products/PriceList'
import PriceListExport from '@/pages/BnpCrm/Contracts/PriceListExport/PriceListExport'
import PriceListExportPrint from '@/pages/BnpCrm/Contracts/PriceListExport/PriceListExportPrint'
import log from '@/pages/BnpSys/LogPage/LogBnp'
import SiteSettings from '@/pages/BnpSys/SiteSettings.vue'
import NewSession from '@/pages/BnpCrm/ScrumSessions/NewSession'
import SessionsList from '@/pages/BnpCrm/ScrumSessions/SessionsList'
import MySessionsList from '@/pages/BnpCrm/ScrumSessions/MySessionsList'
// Start Cash Route
import Vorodi from '@/pages/BnpCash/MnuMoshtarian/Vorodi/Vorodi'
import SearchSanad from '@/pages/BnpCash/MnuOmorMali/SmnuHesabdari/SearchSanad'
import SanadRizNew from '@/pages/BnpCash/MnuOmorMali/SmnuHesabdari/SanadRizNew'
import Daryaft from '@/pages/BnpCash/MnuOmorMali/SmnuHesabdari/Daryaft'
import SearchTaahod from '@/pages/BnpCash/MnuOmorMali/SmnuHesabdari/SearchTaahod'
import AzaPasAndJari from '@/pages/BnpCash/MnuMoshtarian/Vorodi/AzaPasAndJari'
import AzaHesabHa from '@/pages/BnpCash/MnuMoshtarian/Vorodi/AzaHesabHa'
import Pardakht from '@/pages/BnpCash/MnuOmorMali/SmnuHesabdari/Pardakht'
import AzaTashilats from '@/pages/BnpCash/MnuMoshtarian/Vorodi/AzaTashilats'
import Hoze from '@/pages/BnpCash/BasicInfo/Hoze'
import AzaInfo from '@/pages/BnpCash/MnuMoshtarian/Azainfo/AzaInfo'
import ZamenVaMoaref from '@/pages/BnpCash/MnuMoshtarian/ZamenVaMoaref/ZamenVaMoaref'
import AnvaMoshtarian from '@/pages/BnpCash/BasicInfo/AnvaMoshtarian'
import CashSMSPanel from '@/pages/BnpCash/MnuAbzar/CashSMSPanel'
import Jobs from '@/pages/BnpCash/BasicInfo/Jobs'
import lastLogin from '@/pages/BnpSys/LogPage/lastLogin'
// End Cash Route

//Start Automation
import Workflow from '@/pages/BnpAutomation/Workflow/Workflow'
import LeaveRequests from '@/pages/BnpAutomation/Leave/LeaveRequests'
import OverTime from '@/pages/BnpAutomation/Requests/OverTime'
import Mission from '@/pages/BnpAutomation/Requests/Mission'
import AutomationDepartmen from '@/pages/BnpAutomation/AutomationDepartmen/AutomationDepartmen'
import CostPermission from '@/pages/BnpAutomation/CostPermission/CostPermission'
import PaymentPermission from '@/pages/BnpAutomation/PaymentPermission/PaymentPermission'
import BuyRequest from '@/pages/BnpAutomation/BuyRequest/BuyRequest'
import ListProcessWorkFlow from '@/pages/BnpAutomation/ListProcessWorkFlow'
//End Automation

// TaxSystem
import TaxSetting from '@/pages/TaxSystem/TaxSetting/TaxSetting.vue'
import TaxInvoice from '@/pages/TaxSystem/TaxInvoice/TaxInvoice.vue'
import InqueryInvoice from '@/pages/TaxSystem/InqueryInvoice/InqueryInvoice.vue'
import ReportCartablUsers from '@/pages/BnpAutomation/AutomationReport/ReportCartablUser.vue'

//Start  BnpSalary
import Workshop from '@/pages/BnpSalary/Workshop.vue'
import DetailWorkshop from '@/pages/BnpSalary/DetailWorkshop.vue'
import Personnel from '@/pages/BnpSalary/Personnel.vue'
import DetailPersonnel from '@/pages/BnpSalary/DetailPersonnel.vue'
import LegalRuling from '@/pages/BnpSalary/LegalRuling'
import Salary from '@/pages/BnpSalary/Salary'
import ListSalary from '@/pages/BnpSalary/ListSalary'
import PersonelFish from '@/pages/BnpSalary/PersonelFish'
import FishPrint from '@/pages/BnpSalary/FishPrint'
import FishSalaryList from '@/pages/BnpSalary/FishSalaryList'
import PrintSalaryList from '@/pages/BnpSalary/PrintSalaryList'
import PrintInsuranceList from '@/pages/BnpSalary/PrintInsuranceList'
import InsuranceDiskette from '@/pages/BnpSalary/InsuranceDiskette'
import PersonelAttachments from '@/pages/BnpSalary/PersonelAttachments'
import MyFish from '@/pages/BnpSalary/MyFish'
import TaxDiskette from '@/pages/BnpSalary/TaxDiskette'
import SarfaslSalary from '@/pages/BnpSalary/SarfaslSalary'
import FormulaSalary from '@/pages/BnpSalary/FormulaSalary'
//End BnpSalary
Vue.use(VueRouter)

export const routes = [
  {
    path: '',
    name: 'Login',
    component: Login,
  },
  { path: '/ChekLicense', name: 'ChekLicense', component: ChekLicense },
  { path: '/RememberPassword', name: 'RememberPassword', component: RememberPassword },
  {
    path: '/Verify/:Status',
    component: Verify,
    name: 'Verify',
    props: true,
    query: true,
  },
  {
    path: '/Print',
    component: Print,
    name: 'Print',
    props: true,
    query: true,
  },
  {
    path: '/PrintFactor',
    component: PrintFactor,
    name: 'PrintFactor',
    props: false,
    query: true,
  },
  {
    path: '/PriceListExportPrint',
    name: 'PriceListExportPrint',
    component: PriceListExportPrint,
    props: true,
  },
  {
    path: '/PrintTempFactor',
    component: PrintTempFactor,
    name: 'PrintTempFactor',
    props: true,
    query: true,
  },
  {
    path: '/FishPrint',
    name: 'FishPrint',
    component: FishPrint,
    props: true,
  },
  {
    path: '/PrintSalaryList',
    name: 'PrintSalaryList',
    component: PrintSalaryList,
    props: true,
  },
  {
    path: 'PrintInsuranceList',
    name: 'PrintInsuranceList',
    component: PrintInsuranceList,
    props: true,
  },
  {
    path: '/app',
    name: 'Layout',
    component: Layout,
    children: [
      { path: 'dashboard', name: 'Dashboard', component: Dashboard },
      { path: 'DashboardSales', name: 'DashboardSales', component: DashboardSales },
      { path: 'MiddPage', name: 'MiddPage', component: MiddPage },
      {
        path: 'DefineDastresi',
        name: 'DefineDastresi',
        component: DefineDastresi,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'DefineDastresi')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'license',
        name: 'license',
        component: license,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'license')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'log',
        name: 'log',
        component: log,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'log')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SiteSettings',
        name: 'SiteSettings',
        component: SiteSettings,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SiteSettings')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'AutomationDepartmen',
        name: 'AutomationDepartmen',
        component: AutomationDepartmen,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'AutomationDepartmen')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'CostPermission',
        name: 'CostPermission',
        component: CostPermission,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'CostPermission')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'PaymentPermission',
        name: 'PaymentPermission',
        component: PaymentPermission,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PaymentPermission')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'TaxSetting',
        name: 'TaxSetting',
        component: TaxSetting,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TaxSetting')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'TaxInvoice',
        name: 'TaxInvoice',
        component: TaxInvoice,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TaxInvoice')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'InqueryInvoice',
        name: 'InqueryInvoice',
        component: InqueryInvoice,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'InqueryInvoice')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'BuyRequest',
        name: 'BuyRequest',
        component: BuyRequest,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'BuyRequest')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'ListProcessWorkFlow',
        name: 'ListProcessWorkFlow',
        component: ListProcessWorkFlow,
        props: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'ListProcessWorkFlow')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'Detaillicense',
        name: 'Detaillicense',
        component: Detaillicense,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'license')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'ViewHistory',
        name: 'ViewHistory',
        component: ViewHistory,
      },
      {
        path: 'Phonebook',
        name: 'Phonebook',
        component: Phonebook,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Phonebook')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'TarifKarbaran',
        name: 'TarifKarbaran',
        component: TarifKarbaran,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TarifKarbaran')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SmsTemplate',
        name: 'SmsTemplate',
        component: SmsTemplate,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SmsTemplate')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailTarifKarbaran',
        name: 'DetailTarifKarbaran',
        component: DetailTarifKarbaran,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TarifKarbaran')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'TanzimatUser',
        name: 'TanzimatUser',
        component: TanzimatUser,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TanzimatUser')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      { path: 'ThemeButton', name: 'ThemeButton', component: ThemeButton },
      {
        path: 'UserLogInformation',
        name: 'UserLogInformation',
        component: UserLogInformation,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'UserLogInformation')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'CustomerManager',
        name: 'CustomerManager',
        component: CustomerManager,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'CustomerManager')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailCustomer',
        name: 'DetailCustomer',
        component: DetailCustomer,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'CustomerManager')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'MargeCustomer',
        name: 'MargeCustomer',
        component: MargeCustomer,
        props: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'CustomerManager')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'AddCustomer',
        name: 'AddCustomer',
        component: AddCustomer,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'AddCustomer')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DefineShobe',
        name: 'DefineShobe',
        component: DefineShobe,
        AddCustomerbeforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'DefineShobe')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailDefineShobe',
        name: 'DetailDefineShobe',
        component: DetailDefineShobe,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'DefineShobe')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DefineInfoSystem',
        name: 'DefineInfoSystem',
        component: DefineInfoSystem,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'DefineInfoSystem')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailDefineInfoSystem',
        name: 'DetailDefineInfoSystem',
        component: DetailDefineInfoSystem,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'DefineInfoSystem')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'TarifSematha',
        name: 'TarifSematha',
        component: TarifSematha,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TarifSematha')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailTarifSematha',
        name: 'DetailTarifSematha',
        component: DetailTarifSematha,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TarifSematha')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Task',
        name: 'Task',
        component: Task,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Task')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailTask',
        name: 'DetailTask',
        component: DetailTask,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Task')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'TaskManager',
        name: 'TaskManager',
        component: TaskManager,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TaskManager')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Contract',
        name: 'Contract',
        component: Contract,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Contract')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Factor',
        name: 'Factor',
        component: Factor,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Factor')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'TempFactor',
        name: 'TempFactor',
        component: TempFactor,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TempFactor')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'PriceList',
        name: 'PriceList',
        component: PriceList,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PriceList')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'FactorManager',
        name: 'FactorManager',
        component: FactorManager,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'FactorManager')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailContract',
        name: 'DetailContract',
        component: DetailContract,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Contract')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailCustomerProduct',
        name: 'DetailCustomerProduct',
        component: DetailCustomerProduct,
        props: true,
        DetailCustomerProduct,
        beforeEnter(to, from, next) {
          next()
        },
      },
      {
        path: 'Products',
        name: 'Products',
        component: Products,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Products')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'CustomerSms',
        name: 'CustomerSms',
        component: CustomerSms,
        props: true,
      },

      {
        path: 'MenuManager',
        name: 'MenuManager',
        component: MenuManager,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'MenuManager')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Survey',
        name: 'Survey',
        component: Survey,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Survey')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailSurvey',
        name: 'DetailSurvey',
        component: DetailSurvey,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Survey')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Department',
        name: 'Department',
        component: Department,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Department')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Tickets',
        name: 'Tickets',
        component: Tickets,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Tickets')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'CreateTicket',
        name: 'CreateTicket',
        component: CreateTicket,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'CreateTicket')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'PersonelTicket',
        name: 'PersonelTicket',
        component: PersonelTicket,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PersonelTicket')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Deposit',
        name: 'Deposit',
        component: Deposit,
        props: true,
      },
      {
        path: 'Grouping',
        name: 'Grouping',
        component: Grouping,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Grouping')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Cataloge',
        name: 'Cataloge',
        component: Cataloge,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Cataloge')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'NoticeBoard',
        name: 'NoticeBoard',
        component: NoticeBoard,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'NoticeBoard')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailModules',
        name: 'DetailModules',
        component: DetailModules,
        props: true,
      },
      {
        path: 'Modules',
        name: 'Modules',
        component: Modules,
        props: true,
      },
      {
        path: 'ServiceBuy',
        name: 'ServiceBuy',
        component: ServiceBuy,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu') != undefined) {
            if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'ServiceBuy')[0].isMojaz == 0) {
              next('/app/dashboard')
            } else {
              next()
            }
          } else {
            next({
              name: 'Login',
              query: {
                nextUrl: to.fullPath,
              },
            })
          }
        },
      },
      {
        path: 'MyProducts',
        name: 'MyProducts',
        component: MyProducts,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'MyProducts')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'EducationManage',
        name: 'EducationManage',
        component: EducationManage,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'EducationManage')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'FileManage',
        name: 'FileManage',
        component: FileManage,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'FileManage')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'EducationCenter',
        name: 'EducationCenter',
        component: EducationCenter,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'EducationCenter')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'lastLogin',
        name: 'lastLogin',
        component: lastLogin,
        props: true,
      },
      {
        path: 'FileCenter',
        name: 'FileCenter',
        component: FileCenter,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'FileCenter')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Myfiles',
        name: 'Myfiles',
        component: Myfiles,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Myfiles')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      { path: 'ChatRoom', name: 'ChatRoom', component: ChatRoom, props: true },
      {
        path: 'SimilarCustomers',
        name: 'SimilarCustomers',
        component: SimilarCustomers,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SimilarCustomers')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DemoRequest',
        name: 'DemoRequest',
        component: DemoRequest,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'DemoRequest')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'ContractReminderReport',
        name: 'ContractReminderReport',
        component: ContractReminderReport,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'ContractReminderReport')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'developRport',
        name: 'developRport',
        component: developRport,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'developRport')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SmsReport',
        name: 'SmsReport',
        component: SmsReport,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SmsReport')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'markentingReport',
        name: 'markentingReport',
        component: markentingReport,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'markentingReport')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'ActiveNoSupport',
        name: 'ActiveNoSupport',
        component: ActiveNoSupport,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'ActiveNoSupport')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'CustomerScore',
        name: 'CustomerScore',
        component: CustomerScore,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'CustomerScore')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'GardeshHesab',
        name: 'GardeshHesab',
        component: GardeshHesab,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'GardeshHesab')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DebtorList',
        name: 'DebtorList',
        component: DebtorList,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'DebtorList')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'marketerCalls',
        name: 'marketerCalls',
        component: marketerCalls,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'marketerCalls')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'NoFactor',
        name: 'NoFactor',
        component: NoFactor,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'NoFactor')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'TicketReport',
        name: 'TicketReport',
        component: TicketReport,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TicketReport')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SaleReport',
        name: 'SaleReport',
        component: SaleReport,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SaleReport')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DemoReport',
        name: 'DemoReport',
        component: DemoReport,
        props: true,
      },
      {
        path: 'CustomerTicket',
        name: 'CustomerTicket',
        component: CustomerTicket,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'CustomerTicket')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'CartableContract',
        name: 'CartableContract',
        component: CartableContract,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'CartableContract')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'UserIdTask',
        name: 'UserIdTask',
        component: UserIdTask,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'UserIdTask')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      { path: 'ReplyTask', name: 'ReplyTask', component: ReplyTask, props: true },
      { path: 'MyProfile', name: 'MyProfile', component: MyProfile },
      {
        path: 'OnlinePayment',
        name: 'OnlinePayment',
        component: OnlinePayment,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'OnlinePayment')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'TicketAnswer',
        name: 'TicketAnswer',
        component: TicketAnswer,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'TicketAnswer')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'CustomerFinancialInvoice',
        name: 'CustomerFinancialInvoice',
        component: CustomerFinancialInvoice,
        props: true,
      },
      {
        path: 'Alarm',
        name: 'Alarm',
        component: Alarm,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Alarm')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailAlarm',
        name: 'DetailAlarm',
        component: DetailAlarm,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Alarm')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'EmailSetting',
        name: 'EmailSetting',
        component: EmailSetting,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'EmailSetting')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailEmailSetting',
        name: 'DetailEmailSetting',
        component: DetailEmailSetting,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'EmailSetting')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SendEmail',
        name: 'SendEmail',
        component: SendEmail,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SendEmail')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Inbox',
        name: 'Inbox',
        component: Inbox,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Inbox')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'WorkTips',
        name: 'WorkTips',
        component: WorkTips,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'WorkTips')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'PriceListExport',
        name: 'PriceListExport',
        component: PriceListExport,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PriceListExport')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'MyFactors',
        name: 'MyFactors',
        component: MyFactors,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'MyFactors')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'MyTempFactors',
        name: 'MyTempFactors',
        component: MyTempFactors,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'MyTempFactors')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      ///// Start Route Cash
      {
        path: 'Vorodi',
        name: 'Vorodi',
        component: Vorodi,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Vorodi')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Hoze',
        name: 'Hoze',
        component: Hoze,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Hoze')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'AnvaMoshtarian',
        name: 'AnvaMoshtarian',
        component: AnvaMoshtarian,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'AnvaMoshtarian')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'CashSMSPanel',
        name: 'CashSMSPanel',
        component: CashSMSPanel,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'CashSMSPanel')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Jobs',
        name: 'Jobs',
        component: Jobs,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Jobs')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SearchSanad',
        name: 'SearchSanad',
        component: SearchSanad,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SearchSanad')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SanadRizNew',
        name: 'SanadRizNew',
        component: SanadRizNew,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SanadRizNew')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Daryaft',
        name: 'Daryaft',
        component: Daryaft,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Daryaft')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Pardakht',
        name: 'Pardakht',
        component: Pardakht,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Pardakht')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SearchTaahod',
        name: 'SearchTaahod',
        component: SearchTaahod,
        props: true,
      },
      {
        path: 'AzaPasAndJari',
        name: 'AzaPasAndJari',
        component: AzaPasAndJari,
        props: true,
      },
      {
        path: 'AzaHesabHa',
        name: 'AzaHesabHa',
        component: AzaHesabHa,
        props: true,
      },
      {
        path: 'AzaTashilats',
        name: 'AzaTashilats',
        component: AzaTashilats,
        props: true,
      },
      {
        path: 'azainfo',
        name: 'azainfo',
        component: AzaInfo,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'azainfo')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'ZamenVaMoaref',
        name: 'ZamenVaMoaref',
        component: ZamenVaMoaref,
        props: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'AzaPasAndJari')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },

      ///// End Route Cash

      {
        path: 'Workflow',
        name: 'Workflow',
        component: Workflow,
        props: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'AzaPasAndJari')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'LeaveRequests',
        name: 'LeaveRequests',
        component: LeaveRequests,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'LeaveRequests')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'OverTime',
        name: 'OverTime',
        component: OverTime,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'OverTime')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'NewSession',
        name: 'NewSession',
        component: NewSession,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'NewSession')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SessionsList',
        name: 'SessionsList',
        component: SessionsList,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SessionsList')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'MySessionsList',
        name: 'MySessionsList',
        component: MySessionsList,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'MySessionsList')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'Mission',
        name: 'Mission',
        component: Mission,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Mission')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },

      /// Start BnpSalary
      {
        path: 'Workshop',
        name: 'Workshop',
        component: Workshop,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Workshop')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailWorkshop',
        name: 'DetailWorkshop',
        component: DetailWorkshop,
        props: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'DetailWorkshop')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'Personnel',
        name: 'Personnel',
        component: Personnel,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Personnel')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'DetailPersonnel',
        name: 'DetailPersonnel',
        component: DetailPersonnel,
        props: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'DetailPersonnel')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'LegalRuling',
        name: 'LegalRuling',
        component: LegalRuling,
        props: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'LegalRuling')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'Salary',
        name: 'Salary',
        component: Salary,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'Salary')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'SalaryList',
        name: 'SalaryList',
        component: ListSalary,
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'SalaryList')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'PersonelFish',
        name: 'PersonelFish',
        component: PersonelFish,
        props: true,
        query: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PersonelFish')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },

      {
        path: 'FishSalaryList',
        name: 'FishSalaryList',
        component: FishSalaryList,
        props: true,
        query: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PersonelFish')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'InsuranceDiskette',
        name: 'InsuranceDiskette',
        component: InsuranceDiskette,
        props: true,
        query: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PersonelFish')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'TaxDiskette',
        name: 'TaxDiskette',
        component: TaxDiskette,
        props: true,
        query: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PersonelFish')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'SarfaslSalary',
        name: 'SarfaslSalary',
        component: SarfaslSalary,
        props: true,
        query: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PersonelFish')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'PersonelAttachments',
        name: 'PersonelAttachments',
        component: PersonelAttachments,
        props: true,
        query: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'PersonelFish')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'MyFish',
        name: 'MyFish',
        component: MyFish,
        props: true,
        query: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'MyFish')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      {
        path: 'FormulaSalary',
        name: 'FormulaSalary',
        component: FormulaSalary,
        props: true,
        query: true,
        // beforeEnter(to, from, next) {
        //   if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'FormulaSalary')[0].isMojaz == 0) {
        //     next('/app/dashboard')
        //   } else {
        //     next()
        //   }
        // },
      },
      {
        path: 'ReportCartablUsers',
        name: 'ReportCartablUsers',
        component: ReportCartablUsers,
        props: true,
        query: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('Menu').filter((x) => x.RouteName == 'ReportCartablUsers')[0].isMojaz == 0) {
            next('/app/dashboard')
          } else {
            next()
          }
        },
      },
      /// End BnpSalary
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
